import { resolveMpSession } from './mpSession';

/**
 * 组装投诉/建议提交的 multipart：业务 form JSON + 独立 sessionToken 鉴权字段。
 */
export function appendComplaintFormFields(formData, formFields, type, mpSessionProp, routeQuery) {
  const sessionToken =
    (mpSessionProp && String(mpSessionProp).trim()) ||
    resolveMpSession(routeQuery).session ||
    '';
  if (sessionToken) {
    formData.append('sessionToken', sessionToken);
  }
  formData.append('form', JSON.stringify({ ...formFields, type }));
  return sessionToken;
}



// WEBPACK FOOTER //
// ./src/utils/complaintSubmit.js